import React from 'react'
import { Space, Select } from 'antd'

import { state_options } from '../../helper'
import PageSearch from '@/components/PageSearch'
import styles from './index.less'

const fields = [
    {
        name: 'vagueSearch',
        component: PageSearch,
        props: {
            placeholder: '请输入姓名/手机'
        }
    },
    {
        name: 'disabled',
        label: '启用状态',
        component: Select,
        props: {
            style: {
                width: '150px'
            },
            placeholder: '是否启用',
            options: state_options,
            allowClear: true
        }
    }
]

export default ({ value, onChange }) => {
    return (
        <Space className={styles.container}>
            {fields.map(item => (
                <item.component
                    key={item.name}
                    {...(item.props || {})}
                    value={value[item.name]}
                    onChange={val =>
                        onChange({
                            ...value,
                            [item.name]: val
                        })
                    }
                />
            ))}
        </Space>
    )
}
